module.exports = __webpack_public_path__ + "static/media/logo-icon.ac09dcc5.png";